import React from "react";
import { Link } from "react-router-dom";
import "./floatingNavbarMobile.css";

const isLinkActive = (to, currentPath) => {
  if (to === "/organizer") {
    return currentPath.startsWith("/organizer");
  }
  if (to === "/invitations") {
    return currentPath.startsWith("/invitations");
  }
  return currentPath === to;
};

function FloatingNavbarMobile({ links, currentPath }) {
  return (
    <nav className="floating-navbar-mobile" aria-label="Floating mobile navigation">
      {links.map((link) => (
        <Link
          key={link.to}
          to={link.to}
          className={`floating-navbar-mobile-link ${
            isLinkActive(link.to, currentPath) ? "active" : ""
          }`}
        >
          {link.label}
        </Link>
      ))}
    </nav>
  );
}

export default FloatingNavbarMobile;
